import React, { useState } from "react";
import {
  CDropdown,
  CButton,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { ReactComponent as PlusCircle } from "../../../assets/icons/plus-circle.svg";
import OffCanvasComponent from "../offCanvas/OffCanvasComponent";
import InviteNewPatient from "../../pages/dashboard/PatientModals/InviteNewPatient";
import AddNewPatient from "../../pages/dashboard/PatientModals/AddNewPatient";
import InviteWalkInPatient from "../../pages/dashboard/PatientModals/InviteWalkInPatient";
import AddBulkPatient from "../../pages/dashboard/PatientModals/AddBulkPatient";
import { Link } from "react-router-dom";
const PrimaryHeader = ({
  titleText,
  subTitleText = "",
  pillText = "",
  showPill = false,
  showSubtitle = false,
  styles = {},
  classnames = "",
}) => {
  const [newPatientModalStatus, setNewPatientModalStatus] = useState(false);
  const [addPatientModalStatus, setAddPatientModalStatus] = useState(false);
  const [walkinModalStatus, setWalkinModalStatus] = useState(false);
  const [addBulkModalStatus, setAddBulkModalStatus] = useState(false);
  return (
    <div style={{ margin: "0px", padding: "0px" }}>
      <OffCanvasComponent />
      <InviteNewPatient
        modalIsOpen={newPatientModalStatus}
        setIsOpen={setNewPatientModalStatus}
      />
      <AddNewPatient
        modalIsOpen={addPatientModalStatus}
        setIsOpen={setAddPatientModalStatus}
      />
      <InviteWalkInPatient
        modalIsOpen={walkinModalStatus}
        setIsOpen={setWalkinModalStatus}
      />
      <AddBulkPatient
        modalIsOpen={addBulkModalStatus}
        setIsOpen={setAddBulkModalStatus}
      />
      <div
        className="d-flex justify-content-between container-fluid px-1 py-4 w-100"
        style={{ margin: "0px", padding: "0px", ...styles }}
        classnames={`${classnames}`}
      >
        <div
          className="d-flex"
          style={{
            margin: "0px",
            padding: "0px",
            gap: "15px",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <h4
              className="primary-text"
              style={{ textAlign: "start", textTransform: "capitalize" }}
            >
              {titleText}
            </h4>
            {showSubtitle && (
              <span className="secondary-text">{subTitleText}</span>
            )}
          </div>
          {showPill && (
            <div
              style={{
                padding: "5px 8px",
                backgroundColor: "#e5eaf1",
                color: "#344054",
                width: "fit-content",
                height: "fit-content",
                borderRadius: "18px",
              }}
            >
              {pillText}
            </div>
          )}
        </div>
        <CDropdown>
          <CButton
            onClick={() => {
              setNewPatientModalStatus(true);
            }}
            className="dropdown-button-primary"
          >
            <PlusCircle
              fill="white"
              style={{ marginRight: "4px", marginTop: "-2px" }}
            />{" "}
            Invite Patients
          </CButton>
          <CDropdownToggle split className="dropdown-button-primary" />
          <CDropdownMenu>
            {/* <CDropdownItem
              onClick={() => {
                setWalkinModalStatus(true);
              }}
            >
              Invite Walk-in Patient
            </CDropdownItem> */}
            <CDropdownItem
              onClick={() => {
                setAddPatientModalStatus(true);
              }}
            >
              Add Patients
            </CDropdownItem>
            <CDropdownItem>
              <a href="/patients/bhi/" style={{ color: "#0F172A" }}>
                BHI Invite Patients
              </a>
            </CDropdownItem>
            <CDropdownItem
              onClick={() => {
                setAddBulkModalStatus(true);
              }}
            >
              Add Bulk Patients
            </CDropdownItem>
            <CDropdownItem>
              <Link
                to="#"
                onClick={() => {
                  window.location.replace("/patients/invited/");
                }}
                style={{ color: "#0F172A" }}
              >
                View Invited Patients
              </Link>
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </div>
    </div>
  );
};

export default PrimaryHeader;
